<script>
import {BCard, BCardTitle, BRow, BCol} from 'bootstrap-vue'
import {Button} from "@core/components/common";
export default {
    components: {BCard, BCardTitle, BRow, BCol, Button},
    props: {
        title: {
            default: 'Name me'
        },
        elements: {
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            items: []
        };
    },
}
</script>

<template>
    <b-card no-body>
        <div class="card-header pb-1">
            <b-card-title>
                {{ title }}
            </b-card-title>
            <div class="demo-inline-spacing pt-0 mt-0">
                <Button
                    class="btn-icon mt-0 mr-0"
                    @click="$emit('add')"
                >
                    <feather-icon icon="PlusIcon" />
                </Button>
            </div>
        </div>
        <div class="p-2">
            <slot name="row" :items="elements">
                <b-row
                    v-for="(item, index) in elements"
                >
                    <slot name="content-col">
                        <b-col lg="11" md="10">
                            <slot v-bind:item="item" v-bind:index="index" />
                        </b-col>
                    </slot>
                    <slot name="remove-button-col">
                        <b-col lg="1" md="2" class="mt-auto my-auto text-right">
                            <Button class="btn-icon mt-0 mr-0" @click="$emit('remove', {item, index})">
                                <feather-icon icon="MinusIcon"/>
                            </Button>
                        </b-col>
                    </slot>
                </b-row>
            </slot>
        </div>
    </b-card>
</template>
